/**
 * Wraps a dynamic import for React.lazy. On "Failed to fetch dynamically imported module"
 * (stale Vite HMR / deploy chunk mismatch), reload once then surface the real error.
 * @param {() => Promise<{ default: React.ComponentType }>} importFn
 * @returns {Promise<{ default: React.ComponentType }>}
 */
export function lazyImportRetry(importFn) {
  const run = () => importFn();

  return run().catch((error) => {
    const message = String(error?.message ?? error);
    const isChunkLoadFailure =
      message.includes("Failed to fetch dynamically imported module") ||
      message.includes("Importing a module script failed") ||
      message.includes("error loading dynamically imported module") ||
      message.includes("MIME type") ||
      message.includes("text/html");

    if (!isChunkLoadFailure) {
      throw error;
    }

    const reloadKey = "reef:chunk-reload";
    const alreadyReloaded = sessionStorage.getItem(reloadKey) === "1";

    if (!alreadyReloaded) {
      sessionStorage.setItem(reloadKey, "1");
      window.location.reload();
      return new Promise(() => {});
    }

    sessionStorage.removeItem(reloadKey);
    throw error;
  });
}
